export const types = ["up", "down"];
export const validator = dir => types.indexOf(dir) !== -1;
